
export function extractContentType(contentType: string | null): string | undefined {
  if (!contentType) return undefined;
  const contentTypeParts = contentType.split(';');
  return contentTypeParts[0].trim();
}
